import React from 'react'
import { Card, CardBody} from "../../../../../_metronic/_partials/controls";
import styled from 'styled-components'
import { Formik, ErrorMessage } from 'formik';
import { serviceType } from "../../../../variables";
import Select from "react-select";
import * as yup from "yup";


const Modal = styled.div`
    width: 100vw;
    height: 100vh;
    background-color: rgba(25, 33, 43, 0.4);
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000000;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px;
    animation: fadeIn .5s;

    @media (max-width: 768px) {
        padding: 0;
        align-items: start;
        
    }

    & > div{
        max-height: calc(100vh - 100px);
        @media (max-width: 768px) {
            max-height: 100vh;
            height: 100vh;
        }
    }

    .cardBody{
        overflow-y: auto;
    }

    @-webkit-keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
`

export default function EditObservation({setEditListOfObservaion, setObservationData, observationData, row}) {

    const getInputClasses =(touched, errors, fieldname) => {
        if (touched[fieldname] && errors[fieldname]) {
          return "is-invalid";
        }
    
        if (touched[fieldname] && !errors[fieldname]) {
          return "is-valid";
        }
    
        return "";
    };

    const validationSchema = yup.object().shape({
        serviceType: yup.object().shape({label: yup.string().required("Required")}),
        description: yup.string(),
        product: yup.string().required("Product is required"),
        brand: yup.string().required("Brand is required"),
        quantity: yup.number().required("Number of quatity required"),
        charge: yup.number().required("Number of charge/unit required"),
        tax: yup.number().required("Parcentage of tax required"),
    })

    return (
        <Modal>
            <Card style={{width: "700px"}}>
                <div className="d-flex justify-content-between align-items-center pl-10 pr-10 pt-7 pb-7 border-bottom">
                    <div>
                        <h3 className="m-0">Edit Observation</h3>
                    </div>
                    <span className="navi-icon">
                        <i  
                            tabIndex="0" 
                            className="flaticon2-cross"
                            onClick={() => setEditListOfObservaion(false)}
                            style={{cursor:"pointer"}}
                        ></i>
                    </span>
                </div>
                <CardBody className="cardBody">
                    <Formik
                        initialValues={{ 
                            serviceType: row.original.serviceType === "Spare" ? { label: "Spare",value: "Spare"} : {label: "Service",value: "Service"},
                            description: row.original.description,
                            product: row.original.product,
                            brand: row.original.brand,
                            quantity: row.original.quantity,
                            charge: row.original.charge,
                            tax: row.original.tax
                        }}
                        validationSchema={validationSchema}
                        onSubmit={(values, {setSubmitting}) => {
                            setSubmitting(true)

                            let newArrayOfObservation = [...observationData];

                            let subtotal = values.charge * values.quantity
                            let percentage = (values.tax / 100) * subtotal

                            const observation = {
                                serviceType: values.serviceType.value,
                                description: values.description,
                                product: values.product,
                                brand: values.brand,
                                quantity: values.quantity,
                                charge: values.charge,
                                tax: values.tax,
                                total: subtotal + percentage
                            }
                            newArrayOfObservation[row.index] = observation
                            setObservationData([...newArrayOfObservation])
                            setEditListOfObservaion(false)
                            setSubmitting(false)
                        }}
                    >
                    {({
                        values, 
                        errors, 
                        touched, 
                        handleChange, 
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setSubmitting,
                        setFieldValue,
                        isValid,
                        dirty
                    }) => (
                        <form onSubmit={handleSubmit}>
                            
                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label">
                                    Service Type/charge
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <Select
                                        type="text"
                                        name="serviceType"
                                        closeMenuOnSelect={true}
                                        options={serviceType}
                                        getOptionValue={option => option["value"]}
                                        getOptionLabel={option => option["label"]}
                                        onChange={(e) => { 
                                            setFieldValue("serviceType", e)
                                        }}
                                        value={values.serviceType}
                                    />
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label">
                                    Description
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <textarea
                                        type="text"
                                        placeholder="Description"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(touched, errors,
                                            "description"
                                        )}`}
                                        name="description"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.description}
                                    />
                                    <ErrorMessage className="invalid-feedback" component="div" name="description"/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label">
                                    Products
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <input
                                        type="text"
                                        placeholder="Products"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(touched, errors,
                                            "product"
                                        )}`}
                                        name="product"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.product}
                                    />
                                    <ErrorMessage className="invalid-feedback" component="div" name="product"/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label">
                                    Brand
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <input
                                        type="text"
                                        placeholder="Brand"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(touched, errors,
                                            "brand"
                                        )}`}
                                        name="brand"
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        value={values.brand}
                                    />
                                    <ErrorMessage className="invalid-feedback" component="div" name="brand"/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label">
                                    Quantity
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <input
                                        type="text"
                                        placeholder="Quantity"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(touched, errors,
                                            "quantity"
                                        )}`}
                                        name="quantity"
                                        onBlur={handleBlur}
                                        value={values.quantity}
                                        onChange={e => {
                                            e.preventDefault();
                                            const { value } = e.target;
                                            const regex = /^[0-9\b]+$/;
                                            if (value === '' || regex.test(value)) {
                                                setFieldValue("quantity", value);
                                            }
                                        }}
                                    />
                                    <ErrorMessage className="invalid-feedback" component="div" name="quantity"/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label">
                                    Charge/Unit (NGN)
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <input
                                        type="text"
                                        placeholder="Charge/Unit"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(touched, errors,
                                            "charge"
                                        )}`}
                                        name="charge"
                                        onBlur={handleBlur}
                                        value={values.charge}
                                        onChange={e => {
                                            e.preventDefault();
                                            const { value } = e.target;
                                            const regex = /^[0-9\b]+$/;
                                            if (value === '' || regex.test(value)) {
                                                setFieldValue("charge", value);
                                            }
                                        }}
                                    />
                                    <ErrorMessage className="invalid-feedback" component="div" name="charge"/>
                                </div>
                            </div>

                            <div className="form-group row">
                                <label className="col-xl-3 col-lg-3 col-form-label">
                                    Tax (%)
                                </label>
                                <div className="col-lg-9 col-xl-9">
                                    <input
                                        type="number"
                                        placeholder="Charge/Unit"
                                        className={`form-control form-control-lg form-control-solid ${getInputClasses(touched, errors,
                                            "tax"
                                        )}`}
                                        name="tax"
                                        onBlur={handleBlur}
                                        value={values.tax}
                                        onChange={e => {
                                            e.preventDefault();
                                            const { value } = e.target;
                                            const regex = /^[0-9\b]+$/;
                                            // if (value === '' || regex.test(value)) {
                                                setFieldValue("tax", value);
                                            // }
                                        }}
                                    />
                                    <ErrorMessage className="invalid-feedback" component="div" name="tax"/>
                                </div>
                            </div>
                            
                            <div className="col-lg-12 col-xl-12 d-flex justify-content-end">
                                <button
                                    className="btn btn-secondary mr-2"
                                    onClick={() => setEditListOfObservaion(false)}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn btn-primary"
                                    disabled={!isValid || isSubmitting}
                                >
                                    Edit Observation
                                </button>
                            </div>
                            
                        </form>
                        )}
                    </Formik>
                </CardBody>
            </Card>
        </Modal>
    )
}
